import { salesOrderService } from '@/services/salesOrderService';

export function openSalesOrderNotice(uiStore, { title, description }) {
  const modalId = uiStore.addModal(false, {
    title,
    description,
    status: 'warning',
    hideCancel: true,
    submitText: 'Sluiten',
    onSubmit: () => uiStore.closeModal(modalId),
  });
  return modalId;
}

export function salesOrderBlockFromError(error) {
  const data = error?.response?.data;
  if (!data || (data.code !== 'SALES_ORDER_IN_EXECUTION' && data.code !== 'SALES_ORDER_REQUIRED')) {
    return null;
  }
  return {
    title: data.details?.title || 'Dit kan niet meer',
    description: data.error,
  };
}

/**
 * When a sales order exists, replace the generic confirm copy or stop
 * before the action if execution has already started.
 * Returns null when the caller should keep the existing dialog.
 */
export async function salesOrderRevertPreview(proposalId, action) {
  try {
    const preview = await salesOrderService.revertPreview(proposalId, action);
    if (!preview?.applies) return null;
    return preview;
  } catch {
    return null;
  }
}
